import { FillBar } from '@alison/ui';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import type { CreativeScoreComponent, CreativeScoreComponentName } from './data/creativeScore';
import { CREATIVE_SCORE_COMPONENT_ACCENT } from './data/presentation';
import { accentColor } from './MetricTile';

export function CreativeScoreComponentRow({
  name,
  component,
  label,
}: {
  name: CreativeScoreComponentName;
  component: CreativeScoreComponent;
  label: string;
}): ReactNode {
  const theme = useTheme();
  const color = accentColor(theme, CREATIVE_SCORE_COMPONENT_ACCENT[name]);

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: color, flexShrink: 0 }} />
        <Typography sx={{ flex: 1, fontSize: 12, fontWeight: 700, color: 'text.primary' }}>
          {label}
        </Typography>
        <Typography sx={{ fontSize: 12, fontWeight: 700, color: 'text.primary' }}>
          {component.score === null ? 'No data' : Math.round(component.score)}
        </Typography>
        <Typography sx={{ width: 32, fontSize: 11, color: 'text.secondary', textAlign: 'right' }}>
          {`${Math.round(component.weight * 100)}%`}
        </Typography>
      </Box>
      <FillBar color={color} percent={component.score} label={label} height={4} sx={{ mt: 1 }} />
    </Box>
  );
}
